import config from '@epi-config';
import { post } from '@epi-helpers/FetchHelpers';
import { IErrorResponse } from '@epi-models/containers/ErrorData';

const url = `${config.apiHost}/api/einvoice`;

export function validateEInvoiceRequest(
  payload: any
): Promise<{ valid: boolean } | IErrorResponse> {
  return post(`${url}/validate`, payload);
}
